import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { z } from "zod";
//#region src/cues/v1/media/cues/post.ts
var post_exports = /* @__PURE__ */ __exportAll({ RequestSchema: () => RequestSchema });
var RequestSchema = z.object({
	name: z.string(),
	position: z.string(),
	visibility: z.enum([
		"private",
		"org",
		"public"
	])
});
//#endregion
export { post_exports };

//# sourceMappingURL=post.js.map